import { Ray } from "@babylonjs/core/Culling/ray";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractRoomTool } from "./tools";
import { RoomWizard } from "../RoomWizard";
import { Util } from "../utils/Util";
import { CameraMode } from "@egr/wcf/modules/core/view/CameraControl";
import { DeleteElements } from "@egr/wcf/modules/core/cmd";
import { InteractionMode } from "@egr/wcf/modules/core/tool";
import { Log } from "@egr/wcf/modules/utils";
export class RoomAR extends AbstractRoomTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.onCameraChanged = () => {
            this.createCamRay();
        };
        this.mPointCount = 0;
        this.mCamRay = Ray.Zero();
        this.mRaySteps = 0;
    }
    get type() {
        return (this.mType);
    }
    start(pParameter) {
        this.mView = null;
        this.mPoints = new Array();
        this.setInteractionMode(InteractionMode.Primary);
        this.mApp.model.beginSelectionChange();
        this.mApp.model.setSelection([]);
        this.mRoomManager.beginInteraction();
        this.createARPicker();
        this.addCamListener();
        if (this.mRoomElement != null) {
            if (this.mRoomElement.geometry.getType() == "RoomAR")
                this.mRoomElement.geometry.clearPoints([]);
            this.mRoomElement.setStatus("AR_WallRecognition");
        }
        this.mRoomManager.eventARRoomRecognitionStarted.trigger(this.mRoomManager);
        this.mRoomManager.app.model.notifyModification();
        this.mApp.viewer.requestRenderFrame();
        return (super.start(pParameter));
    }
    stop() {
        if (this.mRoomElement != null) {
            this.mRoomElement.dispose();
            this.mRoomElement = null;
        }
        super.stop();
        this.removeCamListener();
        this.finishRoomAR();
        this.mApp.model.setSelection(null);
        this.mRoomManager.endInteraction();
        this.mApp.model.endSelectionChange();
    }
    handlePointerDown(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d(tPointer.position);
        this.handlePDown_RoomAR(tPos, pState);
    }
    addPoint() {
        if (this.mRoomElement == null)
            return;
        if (this.mRoomElement.geometry.getType() == "RoomAR") {
            this.mRoomElement.geometry.addPoint();
            let troomClosed = this.mRoomElement.closedPolygon;
            this.mPointCount = this.mRoomElement.geometry.getPointNumber();
            this.mRoomElement.updateGeometry();
            //this.mApp.viewer.requestRenderFrame();
            if (troomClosed && (this.mRoomElement.status == "AR_WallRecognition")) {
                this.mRoomManager.eventARWallsFinished.trigger(this.mRoomManager);
                this.mRoomElement.setStatus("AR_DoorWindowRecognition");
            }
        }
    }
    removePoint() {
        if (this.mRoomElement == null)
            return;
        if (this.mRoomElement.geometry.getType() == "RoomAR") {
            this.mRoomElement.geometry.removePoint();
            this.mPointCount = this.mRoomElement.geometry.getPointNumber();
            this.mRoomElement.updateGeometry();
            //this.mApp.viewer.requestRenderFrame();
        }
    }
    finishCurrentStatus() {
        if (this.mRoomElement == null)
            return;
        switch (this.mRoomElement.status) {
            case "AR_WallRecognition":
                this.mRoomElement.setStatus("AR_DoorWindowRecognition");
                this.mRoomManager.eventARWallsFinished.trigger(this.mRoomManager);
                break;
            case "AR_DoorWindowRecognition":
                let tPoints = Util.to2dArray(this.mRoomElement.geometry.getPoints());
                /*
                let toldWallPoints: Array<Vector2> = new Array<Vector2>();
                for (let tPoint of tPoints){
                    let tP = tPoint.clone();
                    toldWallPoints.push(tP);
                }

                // create line system
                let toldWallLines: Array<Array<Vector2>> = new  Array<Array<Vector2>>();
                for (let i = 0; i < toldWallPoints.length - 1; i++){
                    let tLine = new Array<Vector2>();
                    let tStart = toldWallPoints[i];
                    let tEnd = toldWallPoints[i + 1];
                    tLine.push(tStart);
                    tLine.push(tEnd);
                    toldWallLines.push(tLine);
                }
                */
                let trotationAngle = RoomWizard.polygonRoom(this.mRoomManager, this.mRoomElement.height, 0.12, tPoints);
                if (trotationAngle == null)
                    return;
                /*
                // line diff
                let tWallsDiff: Array<Vector2> = new Array<Vector2>();
                for (let i = 0; i < toldWallLines.length; i++){
                    let twallDiff = tnewWallLines[i][1].subtract(tnewWallLines[i][0]);
                    tWallsDiff.push(twallDiff);
                }
                */
                let tAROpenings = this.mRoomElement.geometry.AROpenings;
                let tARWalls = trotationAngle.walls;
                for (let tAROpening of tAROpenings) {
                    let tBLheihgt = tAROpening.bottomLeft.y;
                    let tURheihgt = tAROpening.upRight.y;
                    let tWall = tARWalls[tAROpening.wallindex];
                    let twallDirection = tWall[1].subtract(tWall[0]).normalize();
                    let topenStart = twallDirection.scale(tAROpening.startDistance);
                    topenStart = tWall[0].add(topenStart);
                    let topenEnd = twallDirection.scale(tAROpening.startDistance + tAROpening.width);
                    topenEnd = tWall[0].add(topenEnd);
                    //let topenPos = twallDirection.scale(tAROpening.startDistance + (tAROpening.width * 0.5));
                    tAROpening.bottomLeft = topenStart;
                    tAROpening.bottomLeft.y = tBLheihgt;
                    tAROpening.upRight = topenEnd;
                    tAROpening.upRight.y = tURheihgt;
                    let tHP = tAROpening.upRight.clone();
                    tHP.y = tAROpening.bottomLeft.y;
                    tAROpening.position = Util.to2d(Vector3.Center(tAROpening.bottomLeft, tHP));
                }
                this.insertWallOpenings();
                this.stop();
                break;
            default:
                break;
        }
    }
    setOpeningType(pType) {
        if (this.mRoomElement == null)
            return;
        if (this.mRoomElement.type == "RoomAR") {
            this.mRoomElement.geometry.setOpeningType(pType);
        }
    }
    addCamListener() {
        if (this.mView == null) {
            let tView = this.mRoomManager.view;
            if (tView != null) {
                this.mView = tView;
                this.mRoomManager.app.viewer.scene.onBeforeCameraRenderObservable.add(this.onCameraChanged);
            }
            return;
        }
    }
    removeCamListener() {
        this.mRoomManager.app.viewer.scene.onBeforeCameraRenderObservable.removeCallback(this.onCameraChanged);
    }
    rayFilterFloorCeiling(pMesh) {
        let tname = pMesh.name;
        if ((tname.indexOf("ARfloor") == 0) || (tname.indexOf("ARceiling") == 0)) {
            return true;
        }
        return false;
    }
    rayFilterHeightGrabber(pMesh) {
        let tname = pMesh.name;
        if (tname.indexOf("AR_height_grabber") == 0) {
            return true;
        }
        return false;
    }
    rayFilterARWalls(pMesh) {
        let tname = pMesh.name;
        if (tname.indexOf("ARwall__") == 0) {
            return true;
        }
        return false;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createCamRay() {
        if ((this.mRoomElement == null) || (this.mView == null)) {
            return;
        }
        if (this.mView.cameraControl.cameraMode != CameraMode.Perspective) {
            return;
        }
        // set special camera height (head / eyes)
        // this.mView.cameraControl.setPosition(new Vector3(0, 1.8, 0));
        let ttestPos = this.mView.cameraControl.position.clone();
        let ttestDir = this.mView.cameraControl.direction.clone().normalize();
        this.mCamRay.origin = ttestPos;
        this.mCamRay.direction = ttestDir;
        // if (this.mRoomElement.setARStartPointSet(true)){
        //     let tHeightDir = this.mRoomElement.ARStartPoint.subtract(this.mView.cameraControl.position);
        //     tHeightDir.y = ttestDir.y;
        // }
        let trayHit = ([]);
        if (this.mRoomElement.status == "AR_WallRecognition") {
            if ((this.mPointCount != 1) || (this.mRoomElement.heightSet))
                trayHit = this.mRoomManager.app.viewer.scene.multiPickWithRay(this.mCamRay, this.rayFilterFloorCeiling);
            else
                trayHit = this.mRoomManager.app.viewer.scene.multiPickWithRay(this.mCamRay, this.rayFilterHeightGrabber);
            if (trayHit == null)
                return;
            if (trayHit.length > 0) {
                for (let tHit of trayHit) {
                    if ((tHit.pickedPoint != null && tHit.pickedMesh != null) &&
                        (((tHit.pickedMesh.name.indexOf("ARfloor") == 0) || (tHit.pickedMesh.name.indexOf("ARceiling") == 0) ||
                            (tHit.pickedMesh.name.indexOf("AR_height_grabber") == 0))) &&
                        (this.mRoomElement != null)) {
                        this.mRoomElement.geometry.showViewPoint(tHit.pickedPoint, tHit.pickedMesh);
                    }
                }
            }
            else {
                //...
            }
        }
        if (this.mRoomElement.status == "AR_DoorWindowRecognition") {
            trayHit = this.mRoomManager.app.viewer.scene.multiPickWithRay(this.mCamRay, this.rayFilterARWalls);
            if (trayHit == null)
                return;
            if (trayHit.length > 0) {
                for (let tHit of trayHit) {
                    if (((tHit.pickedPoint != null && tHit.pickedMesh != null) &&
                        (tHit.pickedMesh.name.indexOf("ARwall__") == 0)) &&
                        (this.mRoomElement != null)) {
                        this.mLastPickedPoint = tHit.pickedPoint;
                        this.mLastPickedMesh = tHit.pickedMesh;
                        this.mRoomElement.geometry.showViewPoint(tHit.pickedPoint, tHit.pickedMesh);
                    }
                }
            }
            else if (this.mLastPickedMesh != null) {
                this.mRoomElement.geometry.showViewPoint(this.mLastPickedPoint, this.mLastPickedMesh);
            }
        }
    }
    createARPicker() {
        let tARpicker = this.mRoomManager._createARpicker(this.mPoints);
        if (tARpicker != null) {
            this.mRoomElement = tARpicker;
            this.mRoomElement.setToolRunning(true);
        }
    }
    updatePointerPosition(pPos) {
        this.mApp.viewer.requestRenderFrame();
    }
    insertWallOpenings() {
        if (this.mRoomElement == null)
            return;
        let tAROpenings = this.mRoomElement.geometry.AROpenings;
        for (let tAROpening of tAROpenings) {
            this.mRoomManager.insertWallOpeningAR(tAROpening.type, tAROpening.wallindex, tAROpening.position, tAROpening.width, tAROpening.height, tAROpening.parapet);
        }
    }
    handlePDown_RoomAR(pPos, pState) {
        this.addPoint();
    }
    finishRoomAR() {
        if (this.mRoomElement == null) {
            return;
        }
        if (this.mRoomElement != null) {
            this.mRoomElement.setToolRunning(false);
        }
        let tCommand = new DeleteElements(this.mApp, [this.mRoomElement]);
        if (tCommand.isAvailable()) {
            let tPromise = this.mApp.commands.executeCommand(tCommand);
            this.removeCamListener();
            this.mRoomManager.endInteraction();
            this.mRoomManager.app.model.notifyModification();
            this.mApp.viewer.requestRenderFrame();
            tPromise.catch((pError) => {
                Log.error("Failed to delete buildings", pError);
            });
        }
    }
}
